import { render, staticRenderFns } from "./TextNoteContentFormMarkdownButtons.vue?vue&type=template&id=5f92aa89&scoped=true"
import script from "./TextNoteContentFormMarkdownButtons.vue?vue&type=script&lang=js"
export * from "./TextNoteContentFormMarkdownButtons.vue?vue&type=script&lang=js"
import style0 from "./TextNoteContentFormMarkdownButtons.vue?vue&type=style&index=0&id=5f92aa89&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f92aa89",
  null
  
)

export default component.exports